// Safe localStorage wrapper — never throws.
// Handles cases where storage is disabled, blocked (iframe, private mode,
// SecurityError), or unavailable (SSR / prerender).
// Falls back to in-memory storage so the app keeps working.

const memoryStore = {};

function getStorage() {
  try {
    if (typeof window === "undefined") return null;
    // Probe access — some browsers throw on the property access itself.
    const ls = window.localStorage;
    const testKey = "__bv_probe__";
    ls.setItem(testKey, "1");
    ls.removeItem(testKey);
    return ls;
  } catch (_e) {
    return null;
  }
}

export const safeStorage = {
  getItem(key) {
    try {
      const ls = getStorage();
      if (ls) return ls.getItem(key);
    } catch (_e) {}
    return Object.prototype.hasOwnProperty.call(memoryStore, key)
      ? memoryStore[key]
      : null;
  },
  setItem(key, value) {
    try {
      const ls = getStorage();
      if (ls) {
        ls.setItem(key, value);
        return;
      }
    } catch (_e) {}
    memoryStore[key] = String(value);
  },
  removeItem(key) {
    try {
      const ls = getStorage();
      if (ls) {
        ls.removeItem(key);
        return;
      }
    } catch (_e) {}
    delete memoryStore[key];
  },
};

export default safeStorage;
